// note this input component accepts formik prop

import React from 'react';
import PropTypes from 'prop-types';

import {
  STRING_FIELD_FULL_NAME,
} from '../labels';

import FormikLabeledField from './FormikLabeledField';

import formikPropTypes from './formikPropTypes';

export function FullNameField({
  name, onChange, formikProps,
}) {
  return (
    <FormikLabeledField
      name={name}
      onChange={onChange}
      formikProps={formikProps}
      label={STRING_FIELD_FULL_NAME}
      placeholder={STRING_FIELD_FULL_NAME}
    />
  );
}

FullNameField.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  formikProps: formikPropTypes.isRequired,
};

FullNameField.defaultProps = {
  onChange: () => {},
};

export default FullNameField;
